import React from 'react';
import { X, Check } from 'lucide-react';
const comparisons = [{
  bad: 'Horas planificando desde cero cada semana',
  good: '5 minutos. Todo listo.'
}, {
  bad: 'Sesiones improvisadas sin progresión real',
  good: '+120 sesiones listas por categoría'
}, {
  bad: 'Grupos sin sistema ni continuidad',
  good: 'Estructura clara semana a semana'
}, {
  bad: 'Pretemporada improvisada',
  good: '4 semanas blindadas sin lesionados'
}, {
  bad: 'Sin jugadas de pizarrón cuando el partido está cerrado',
  good: '20 jugadas de pizarrón para destrabar cualquier partido'
}, {
  bad: 'Llegar al campo con ansiedad',
  good: 'Llegar al campo con claridad total'
}];
export function Comparison() {
  return <section className="bg-white py-20 px-4" data-id="element-38">
      <div className="max-w-4xl mx-auto" data-id="element-39">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 text-center mb-12" data-id="element-40">
          ¿Cuánto cuesta NO tenerlo?
        </h2>

        <div className="bg-white rounded-2xl shadow-xl overflow-hidden border border-gray-200 mb-12" data-id="element-41">
          <div className="grid grid-cols-2 bg-gray-50 border-b border-gray-200" data-id="element-42">
            <div className="p-6 text-center font-bold text-xl text-gray-500" data-id="element-43">
              Sin RUGBY 360
            </div>
            <div className="p-6 text-center font-bold text-xl text-[#1B4D2E] bg-green-50" data-id="element-44">
              Con RUGBY 360
            </div>
          </div>

          <div className="divide-y divide-gray-100" data-id="element-45">
            {comparisons.map((item, i) => <div key={i} className="grid grid-cols-2" data-id="element-46">
                <div className="p-6 flex items-start gap-3 text-gray-600" data-id="element-47">
                  <X className="text-red-500 flex-shrink-0 mt-1" size={20} data-id="element-48" />
                  <span className="text-lg" data-id="element-49">{item.bad}</span>
                </div>
                <div className="p-6 flex items-start gap-3 text-gray-900 font-medium bg-green-50/30" data-id="element-50">
                  <Check className="text-green-600 flex-shrink-0 mt-1" size={20} data-id="element-51" />
                  <span className="text-lg" data-id="element-52">{item.good}</span>
                </div>
              </div>)}
          </div>
        </div>

        <div className="bg-[#FFF9C4] p-8 rounded-2xl text-center shadow-sm border border-yellow-200" data-id="element-53">
          <p className="text-2xl font-bold text-gray-900" data-id="element-54">
            El martes podés improvisar o llegar al campo con todo resuelto. Vos
            decidís.
          </p>
        </div>
      </div>
    </section>;
}